<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-calendar-minus"></i>
        <h1>הוספת נוכחות</h1>
      </template>
      <div class="p-pt-4 p-fluid p-grid">


      <!--   pupil  -->
        <div class="p-field p-col-12 p-md-6">
          <label>תלמיד</label>
          <Dropdown
              filterPlaceholder=" חפש לפי שם משפחה"
              emptyFilterMessage=" לא נמצא שם משפחה תואם"
              class="p-dropdown-filter-container"
              :filter="true"
              optionLabel="lastname"
              v-model="newItem.pupil"
              :options="pupils"
              placeholder="בחר תלמיד"
              dataKey="id"
              autofocus
          >
            <template #value="slotProps">
              <div v-if="!slotProps.value || slotProps.value.length === 0">
                {{ slotProps.placeholder }}
              </div>
              <span v-else>
                {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
                </span>
            </template>
            <template #option="slotProps">
                <span
                >{{ slotProps.option.grade.hebrewName }}:
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
            </template>
          </Dropdown>
        </div>

        <!--   presenceStatus  -->
        <div class="p-field p-col-12 p-md-6">
          <label>סוג נוכחות</label>
          <Dropdown
              filterPlaceholder=" חפש לפי סוג נוכחות"
              emptyFilterMessage=" לא נמצא שם נוכחות תואם"
              optionLabel="hebrewName"

              :showClear="true"
              dataKey="id"

              :filter="true"
              v-model="newItem.status"
              :options="presenceStatus"
              placeholder="בחר נוכחות"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }} </span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }} </span>
            </template>
          </Dropdown>
        </div>

        <!--   lessonTime  -->
        <div class="p-field p-col-12 p-md-6">
          <label>זמן השיעור</label>
          <Dropdown
              dataKey="id"

              v-model="newItem.time"
              :options="lessonTime"
              placeholder="בחר את זמן השיעור"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }} </span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }} </span>
            </template>
          </Dropdown>
        </div>
        <!--   date  -->
        <div class="p-field p-col-12 p-md-6">
          <label>יום השיעור</label>

          <Calendar
              :showButtonBar="true"
              dateFormat="dd.mm.yy"
              v-model="newItem.date"
              placeholder="תאריך"
          />
        </div>

      </div>

      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button v-if="validateToPost" class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
        <Button v-else disabled="disabled" class="p-button-success" label="הוספה" icon="pi pi-check"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../../service/Service";
import {mapState} from "vuex";
const { v4: uuidv4 } = require("uuid");

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {

    this.service = new Service();
    this.setNewItwmFields();
  },
  computed: {
    validateToPost() {
      if (this.newItem.pupil === null) return false
      if (this.newItem.date === null) return false
      if (this.newItem.time === null) return false
      if (this.newItem.subject === null) return false
      return true
    },
    ...mapState(["presenceStatus","teachers", "pupils", "lessonTime",'user']),
  },
  data() {
    return {
      newItem: null,
      roles: ["USER", "MIKTZOI", "ADMIN"],
      postLock: false
    };
  },

  methods: {
    setNewItwmFields() {
      this.newItem = {
        id: uuidv4(),
        date: new Date,
        time: null,
        status: null,
        pupil: null,
        user: null,
        grade: null,
      };
    },
    getRoleLabel(status) {
      switch (status) {
        case "ADMIN":
          return "מנהל";

        case "USER":
          return "מחנך";

        case "MIKTZOI":
          return "מקצועי";

        default:
          return "NA";
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      // for (const key in this.newItem) {
      //   if (this.newItem[key] === null) {
      //     validate = false;
      //   }
      // }
      // alert(this.postLock)
      if (!this.postLock) {

        if (validate) {
          this.postLock = true
          const pupilObj = JSON.parse(JSON.stringify(this.newItem.pupil))
          const statusObj = JSON.parse(JSON.stringify(this.newItem.status))
          const lessonTimeObj = JSON.parse(JSON.stringify(this.newItem.time))
          const presenceObj = JSON.parse(JSON.stringify(this.newItem))
          const userObj = JSON.parse(JSON.stringify(this.getTeacherObj(this.user.id)))
          const gradeObj = JSON.parse(JSON.stringify(this.newItem.pupil.grade))

          presenceObj.date = Date.parse(presenceObj.date)
          presenceObj.pupil = presenceObj.pupil.id
          presenceObj.status = presenceObj.status.id
          presenceObj.time = presenceObj.time.id
          presenceObj.grade = pupilObj.grade.id
          presenceObj.user = this.user.id

          await this.service
              .post(presenceObj, 'presence')
              .then(() => {
                presenceObj.pupil = pupilObj;
                presenceObj.status = statusObj;
                presenceObj.time = lessonTimeObj;
                presenceObj.user = userObj;
                presenceObj.grade = gradeObj;
                this.$emit("addItem", presenceObj);
                this.setNewItwmFields();
                this.openNotification(
                    "success",
                    `מעולה`,
                    `המשתמש התתוסף במערכת`
                );
                this.closeDialog();
                this.postLock = false

              })
              .catch(() => {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `אולי קיים כבר משתמש עם ת.ז. זהה`
                );
                this.postLock = false

              });
        } else {
          this.openNotification(
              "danger",
              `אופס`,
              `חסרים כמה שדות למילוי`
          );
        }
      }
    },
    getTeacherObj(teacherId) {
      return this.teachers.find((teacher) => teacher.id === teacherId);
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>